"use client"

type NavLineProps = {
  isActive: boolean
  isHovered: boolean
  isClicked: boolean
  left: number
  width: number
}

const NavLine = ({ isActive, isHovered, isClicked, left, width }: NavLineProps) => {
  return (
    <div
      className={`absolute bottom-0 ${isActive || isHovered ? 'h-1 bg-white' : 'h-[3px] bg-white/30'}`}
      style={{
        left,
        width,
        opacity: isHovered || isActive ? 1 : 0.3,
        boxShadow: (isActive || isHovered) ? '0 0 8px rgba(255,255,255,0.8)' : 'none',
        transition: 'none'
      }}
    />
  )
}

export default NavLine
